export const SEARCH_PARAM = 'search';

export const SORT_TYPE_PARAM = 'sortType';

export const TAG_TYPE_PARAM = 'tagType';

export const CHAIN_FILTER_PARAM = 'chainFilter';

export const TAB_PARAM = 'tab';

export const INNER_TAB_PARAM = 'innerTab';

export const TAB_BURN_PARAM = 'burnTab';

export const CUSTOM_ACCOUNT = 'account';

export const CHAIN_PARAM = 'chain';

export const SORT_BY_PARAM = 'sortBy';

export const SORT_DIRECTION_PARAM = 'sortDirection';

export const SHOW_FIND_A_FARM = 'find_farm';

export const SWOW_UNIQ_BY_FARMS = 'isUniqByFarms';
